export const INPUT_VALUE = 'INPUT_VALUE';

/**
 * @return {Object}
 */
export function senderValue(value, name) {
  return {
    type: INPUT_VALUE,
    value,
    name,
  };
}
